import * as Yup from "yup";

export const formConfigurationFormValidationSchema = (editingRole, editing) => (
  Yup.object().shape({
    idArt: Yup.number().nullable().required("Campo Obligatorio"),
    idRol: Yup.number().nullable().required("Campo Obligatorio"),
    idFormulario: editingRole
      ? Yup.number().nullable()
      : Yup.number().nullable().required("Campo Obligatorio"),
  })
);